@if (dataSource) {
    <div fxLayout="row" fxLayoutAlign="start start" class="w-100 h-100" fxLayoutGap="16px">
        <div class="grid-container">
            <div fxLayout="row" fxLayoutAlign="start end">
                <div fxLayout="column" fxLayoutAlign="center start" class="section-container">
                    <div class="t1-semi-bold">{{ sectionTitle | translate }}</div>
                </div>
            </div>
            @for (column of columns; track column) {
                <af-classification-table-header [column]="column"
                                                (dateRangeChanged)="loadDataForColumn(column, $event)"
                />
            }
            @for (row of rowsByContext[context]; track row) {
                <div class="column">
                    <af-classification-row-label class="h-100 w-100"
                                                 [rowLabel]="row"
                                                 [participantRole]="participantRole"
                                                 [hasCurrencyFilter]="dataSource[row].hasCurrencyFilter"
                                                 (selectCurrency)="selectedCurrency[row] = $event"/>
                    @for (column of columns; track column) {
                        <af-classification-table-cell
                            class="h-100"
                            [column]="column"
                            [row]="row"
                            [currency]="selectedCurrency[row]"
                            [dataType]="dataSource[row].dataType"
                            [data]="dataSource[row].columns?.[column]"
                            [maxDataRows]="dataSource[row].maxDataRows"
                            [translationPostfix]="dataSource[row].translationPostfix"
                            (showMoreClickListener)="openCellDetails(row, column, dataSource[row].columns?.[column])"
                        />
                    }
                </div>
            }
        </div>
    </div>
}
